<template>
  <div class="correction-list">
    <v-container class="py-1 px-3 bg-grey-lighten-4" fluid>
      <warehouse-select />
      <v-text-field
        label="Suche"
        variant="filled"
        v-model="fulltextSearch"
        append-inner-icon="mdi-magnify"
        @click:append-inner="doSearch"
        @keypress.enter="doSearch"
        hide-details
        :loading="correctionsStore.loading"
      />
      <filter-list :store="correctionsStore" v-if="!correctionsStore.loading && correctionsStore.displayFilters.length > 0" />
    </v-container>
    <template v-if="!correctionsStore.loading && !correctionsStore.error">
      <v-list lines="two" class="pa-0 border-t">
        <template v-if="correctionsStore.data">
          <!-- changed BelegNr to BuchungNr. -->
          <template
            v-for="correction in correctionsStore.data"
            :key="correction.BelegNr">
            <hr
              role="separator"
              aria-orientation="horizontal"
              class="v-divider"
              theme="light"
            />
            <correction-list-item :correction="correction"/>
            <hr
              role="separator"
              aria-orientation="horizontal"
              class="v-divider"
              theme="light"
            />
          </template>
        </template>
        <v-container fluid class="mb-10">
          <pagination :module="correctionsStore.$id" />
        </v-container>
      </v-list>
    </template>
    <template v-else-if="correctionsStore.error">
      <v-container class="py-1" fluid>
        <error :module="correctionsStore.$id" />
      </v-container>
    </template>
    <template v-else>
      <loading />
    </template>
    <v-btn
      position="fixed"
      icon
      class="ma-3"
      style="z-index: 1;"
      location="right bottom"
      @click="navigate({ name: 'correction_create' })"
      color="primary">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>
<script setup lang="ts">
import FilterList from '@/components/FilterList.vue';
import ErrorComp from '@/components/Error.vue';
import Loading from '@/components/Loading.vue';
import Pagination from '@/components/Pagination.vue';
import WarehouseSelect from '@/components/WarehouseSelect.vue';
import {RouteLocationRaw} from 'vue-router';
import router from '@/router';
import {useStorage} from '@/composables/storage';
import useCorrectionsStore from '@/store/corrections';
import CorrectionListItem from '@/components/Corrections/CorrectionListItem.vue';
import {computed, ref, watch} from 'vue';
import {useFilterSort} from '@/composables/filterSort';

const correctionsStore = useCorrectionsStore();
useStorage(correctionsStore);
function navigate(to: RouteLocationRaw) {
  router.push(to).catch(console.error);
}
const emits = defineEmits(['close']);
const {filters, save} = useFilterSort(correctionsStore, emits);

const searchDebounceTimeout = ref<NodeJS.Timeout | null>(null);
function doSearch() {
  if (searchDebounceTimeout.value) clearTimeout(searchDebounceTimeout.value);
  save();
}

const fulltextSearch = computed({
  get(): string {
    return filters.value.Fulltext$Fulltext.words.join(' ');
  },
  set(val: string) {
    if (!val) {
      filters.value.Fulltext$Fulltext.words = [];
      return;
    }
    filters.value.Fulltext$Fulltext.words = val.split(' ');
  },
});

watch(fulltextSearch, (newVal: string, oldVal: string) => {
  if (newVal === oldVal || newVal.length < 3) return;
  if (searchDebounceTimeout.value) clearTimeout(searchDebounceTimeout.value);

  searchDebounceTimeout.value = setTimeout(() => {
    doSearch();
  }, 500);
});

defineExpose({
  FilterList,
  Error: ErrorComp,
  Loading,
  Pagination,
  WarehouseSelect,
  navigate,
  correctionsStore,
});
</script>
<style scoped>
.item-operator-info .v-chip__content {
  display: flex;
  justify-content: center;
}
.v-pagination__navigation, .v-pagination__item--active {
  box-shadow: none;
}
</style>
